$(function() {

    $('body').on('click', '.fee-range-input', function(event){
        $(this).toggleClass('active', true);

        $(event.delegateTarget).on('click.feerange', function(event) {
            if($(event.target).closest('.fee-range-input').length === 0) {
                $('.fee-range-input').toggleClass('active', false);

                $(this).off('click.feerange');
            }
        })
    });




    var rangeSlider = document.getElementById('range-slider');

    if(rangeSlider) {

        var rangeMin = Math.max(document.getElementById('range-min').value, 0);
        var rangeMax = Math.max(document.getElementById('range-max').value, 0);
        if(rangeMax === 0) {
            rangeMax = 21000;
        }

        noUiSlider.create(rangeSlider, {
            behaviour: 'none',
            connect: true,
            format: {
                to: function(value) {
                    var tooltip = '$' + Math.ceil(value).toLocaleString();
                    if(rangeSlider !== undefined && rangeSlider.hasOwnProperty('noUiSlider')) {
                        if(rangeSlider.noUiSlider.options.range.max === value) {
                            tooltip = '$20,000+';
                        }
                    }
                    return tooltip;
                },
                from: function(value) {
                    return value.replace('$', '').replace(',', '').replace('+', '');
                }
            },
            margin: 1000,
            range: {
                'min': 0,
                'max': 21000
            },
            start: [rangeMin, rangeMax],
            step: 1000,
            tooltips: true
        });

        rangeSlider.noUiSlider.on('update', function(values, handle) {
            var value = values[handle];

            var inputValue = value.replace('$', '').replace(',', '');
            if(inputValue.indexOf('+') !== -1) {
                inputValue = 0;
            }

            document.getElementById( (handle === 0) ? 'range-min' : 'range-max' ).value = inputValue;
            document.getElementById( (handle === 0) ? 'fee-range-min' : 'fee-range-max' ).innerHTML = value;
        });
    }

});